module.exports = __webpack_public_path__ + "img/burger.9c9160f2.svg";